// extracted by mini-css-extract-plugin
module.exports = {"reactMarkdown":"markdownGlobal_reactMarkdown__3TBaO"};